module.exports = "/assets/images/checkmark_8ff628.svg";